const analytics = {
  "Live Mode": "Modo en vivo",
  "Log Scale": "Escala logarítmica",
  Title: "Título",
  "Max Records to Display": "Máximo de registros a mostrar",
  "Time Granularity": "Granularidad de tiempo",
  "X-Axis": "Eje X",
  "Y-Axis": "Eje Y",
  "Chart Type": "Tipo de gráfico",
  Filters: "Filtros",
  "Group By": "Agrupar por",
  "Order By": "Ordenar por",
  Width: "Ancho",
  "Drag and drop fields to configure your chart.":
    "Arrastra y suelta campos para configurar tu gráfico.",
  "Loading chart...": "Cargando gráfico...",
  Preview: "Vista previa",
  "XY Charts": "Gráficos XY",
  "Bar Chart": "Gráfico de barras",
  "Line Chart": "Gráfico de líneas",
  "Scatter Plot": "Diagrama de dispersión",
  "Radial Charts": "Gráficos radiales",
  "Pie Chart": "Gráfico circular",
  "Donut Chart": "Gráfico de dona",
  "Time Series Charts": "Gráficos de series temporales",
  "Grouped Bar": "Barras agrupadas",
  "Stacked Bar": "Barras apiladas",
  "Area Chart": "Gráfico de área",
  Day: "Día",
  Month: "Mes",
  Year: "Año",
  "Data Fields": "Campos de datos",
  "Chart Types": "Tipos de gráfico",
  Order: "Orden",
  "Layout Span": "Distribución del diseño",
  half_width: "Medio ancho",
  full_width: "Ancho completo",
  "Configure your chart": "Configura tu gráfico",
  "Dynamic Filters": "Filtros dinámicos",
  Categories: "Categorías",
  "Drop categories here": "Suelta categorías aquí",
  "Drop value here": "Suelta el valor aquí",
  "Drop chart type here": "Suelta el tipo de gráfico aquí",
  "Drop Label Field Here": "Suelta el campo de etiqueta aquí",
  "Drop Value Field Here": "Suelta el campo de valor aquí",
  "Drop Chart Type Here": "Suelta el tipo de gráfico aquí",
  "Drop X-Axis Field Here": "Suelta el campo del eje X aquí",
  "Drop Y-Axis Field Here": "Suelta el campo del eje Y aquí",
  "Add Filter": "Agregar filtro",
  Sum: "Suma",
  Average: "Promedio",
  Count: "Conteo",
  Minimum: "Mínimo",
  Maximum: "Máximo",
  Median: "Mediana",
  configure: "Configurar",
  failed_to_fetch_chart_data: "Error al obtener los datos del gráfico",
  create_link: "Crear enlace",
  click_target_node: "Haz clic en el nodo objetivo",
  delete_node: "Eliminar nodo",
  delete_link: "Eliminar enlace",
  connections: "Conexiones",
  drag_to_create_node_click_to_select:
    "Arrastra para crear un nodo, haz clic para seleccionar",
  you_do_not_have_any_charts_configured_yet:
    "Aún no tienes ningún gráfico configurado",
  "Add visualization": "Agregar visualización",
  "Update Preview": "Actualizar vista previa",
  last_sync_at: "Última sincronización",
  syncs_daily_at: "- sincronización diaria a las 07:00 AM",
  at_07_00_am: "07:00 AM CET",
};

export default analytics;
